import { connect } from "react-redux";
import { getCloudinaryFullPath } from "../../utils";
import { Themes } from "../../utils/constant";
import { Fade } from "react-awesome-reveal";
import ImageSlider from "../ImageSlider/imageSlider";
import FloatingHearts from "../FloatingHearts/FloatingHearts";

const images = [
  "https://images.unsplash.com/photo-1519741497674-611481863552?q=80&w=1200",
  "https://images.unsplash.com/photo-1522673607200-164d1b6ce486?q=80&w=1200",
  "https://images.unsplash.com/photo-1511285560929-80b456fea0bc?q=80&w=1200",
];

const QuoteSection = ({ quote, quotePhoto, theme }) => {
  return (
    <div
      className="quoteContainer section-padding"
      style={{ ...(Themes.timelessCharm && { padding: "0 0 60px 0" }) }}
    >
      <div className="content section">
        <Fade
          duration={2000} // Animation duration
          triggerOnce // Animate only once
        >
          <div className="photos">
            <div className="thumbnails">
              <FloatingHearts image={getCloudinaryFullPath(quotePhoto)} />

              {/* <div
                style={{
                  height: "100vh",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <ImageSlider images={images} interval={5000} />
              </div> */}
              {/* <img src={getCloudinaryFullPath(quotePhoto)} alt="quote-bg" /> */}
              {/* <div className="black"></div>
            <div className="title">
              <div>
                <i className="fi flaticon-quotation"></i>
              </div>
              <Fade
                className="animate__animated animate__fadeInLeft"
                delay={400}
                duration={1000}
                triggerOnce="true"
              >
                <div style={{ margin: 5 }}>
                  {quote ||
                    "Love is the essence that binds two hearts, and marriage is the celebration that brings those hearts together forever."}
                </div>
                <div>
                  <i className="fi flaticon-quotation"></i>
                </div>
              </Fade>
            </div> */}
            </div>
          </div>
        </Fade>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    quotePhoto: state.inviteDetails.invite?.quotePhoto,
    quote: state.inviteDetails.invite?.quote,
    theme:
      state.inviteDetails?.invite?.themeInfo?.identifier ||
      state.inviteDetails?.theme ||
      "",
  };
};

export default connect(mapStateToProps)(QuoteSection);
